// extracted by mini-css-extract-plugin
module.exports = {"widgetContainerRight":"EventsTimelineViz_widgetContainerRight__13dZd","viewer":"EventsTimelineViz_viewer__1x7zE","timelineContainer":"EventsTimelineViz_timelineContainer__LtFBF"};